import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';

import { Container } from './layout';

export const ZoneIcon = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${(props) => props.color};
  border-radius: 50%;
  line-height: 32px;
  border: 2px solid #fff;
  font-size: 13px;
  color: white;
  display: flex;
  font-weight: bold;
  justify-content: center;
  align-items: center;
`;

export const Ellipsis = styled.div`
  margin-left: 10px;
  font-size: 22px;
  &.small {
    font-size: 15px;
    margin-left: 5px;
  }
  /* top: 4px; */
`;

/**
 * page
 */
export const PageWrapper = styled(Container)`
  margin: auto;
  position: relative;
  margin-top: 25px;
`;

export const Headline = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  font-size: 26px;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      margin-bottom: 16px;
    `}
  ${(props) =>
    props.$mb &&
    css`
      margin: 0 0 45px;
    `}
  ${(props) =>
    props.$alignLeft &&
    css`
      justify-content: flex-start;
    `}
`;

export const HeadLineWithMargin = styled(Headline)`
  margin-bottom: 35px;
`;

/**
 * card
 */
export const CardWrapper = styled(Container)`
  padding: 10px;
  background-color: #393e44;
  min-height: 100px;
  border-radius: 2px;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      &.mt20 {
        margin-top: 20px;
      }
      background-color: var(--cp-surface);
      color: var(--cp-text);
      border: 1px solid var(--cp-border);
      border-radius: 16px;
      padding: 22px 24px;
      box-shadow:
        0 1px 2px rgba(16, 24, 32, 0.04),
        0 6px 22px rgba(16, 24, 32, 0.05);
    `}
`;

export const Card = styled.div`
  border-radius: 2px;
  /* v2: clean surface card (rounded, bordered) instead of a dark slab */
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      &.mt20 {
        margin-top: 20px;
      }
      border-radius: 16px;
      /* overflow visible so date-pickers / dropdowns inside the card are not
         clipped at the card edge; corners are rounded on the first/last child
         instead of via overflow:hidden. */
      overflow: visible;
      border: 1px solid var(--cp-border);
      background: var(--cp-surface);
      box-shadow:
        0 1px 2px rgba(16, 24, 32, 0.04),
        0 6px 22px rgba(16, 24, 32, 0.05);
      & > *:first-child {
        border-top-left-radius: 16px;
        border-top-right-radius: 16px;
      }
      & > *:last-child {
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
      }
    `}
`;

export const GeneralInfo = styled.div`
  position: relative;
  height: 170px;
  background-color: #262b31;
  padding: 20px 20px 0 20px;
  &.new-tariff {
    display: flex;
  }
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      height: auto;
      background-color: var(--cp-surface);
      border-bottom: 1px solid var(--cp-border);
      color: var(--cp-text);
      padding: 22px 24px 0;
      &.new-tariff {
        display: flex;
        padding-bottom: 22px;
      }
    `}
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #393e44;
  min-height: 480px; //600
  padding: 25px 20px;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      background-color: var(--cp-surface);
      color: var(--cp-text);
      min-height: auto;
      padding: 22px 24px;
    `}
`;

export const DataWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #393e44;
  min-height: 480px; //600
  padding: 25px 20px;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      background-color: var(--cp-surface);
      color: var(--cp-text);
      min-height: auto;
      padding: 22px 24px;
    `}
`;

export const SectionLinksWrapper = styled.div`
  margin: 15px 0 0 0;
  min-height: 30px;
  &.double {
    display: flex;
    flex-wrap: wrap;
    > * {
      margin: 0 40px 0px 0;
    }
  }
  /* v2: a full-width baseline under the tabs + a clear gap before the filter
     panel, so the active tab's green underline no longer clashes with the
     rounded panel corner below it. */
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      margin: 15px 0 20px 0;
      border-bottom: 1px solid var(--cp-border);
    `}
`;

export const SectionLink = styled(NavLink)`
  margin: 0 30px 0 0;
  min-width: 30px;
  opacity: 0.6;
  font-size: 15px;
  color: ${(props) => (props.theme.theme === 'dark' ? '#aaa' : '#000')};
  padding: 0 0 8px 0;
  white-space: nowrap;
  &.active {
    opacity: 1;
    border-bottom: 4px solid var(--cp-accent, #3ea5ff);
    color: var(--cp-accent, #3ea5ff);
    font-weight: 900;
    font-size: 16px;
  }
  &:focus-visible {
    outline: 2px solid var(--cp-accent, #3ea5ff);
    outline-offset: 3px;
    border-radius: 6px;
  }
`;

/**
 * windows
 */
export const Header = styled.h1`
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: ${(props) => (props.theme.theme === 'dark' ? '#ccc' : '#262b31')};
`;

export const MainBlock = styled.div`
  font-size: 15px;
  color: #3e3e3e;
  ${(props) =>
    (props.theme.theme === 'dark' || props.theme.ui === 'v2') &&
    css`
      color: var(--cp-text-secondary);
    `}
`;

export const InputWithHelp = styled.div`
  margin: 0 0 5px;
  display: flex;
  align-items: center;
  label:not(.toggle) {
    font-size: 16px;
    min-width: 310px;
  }
  &.pt20 {
    padding-top: 20px;
  }
  &.inVerticalForm {
    position: relative;
    & > div:first-child {
      width: 100%;
    }
    label:not(.toggle) {
      font-size: 13px;
      min-width: 200px;
    }
    .in-tariff label:not(.toggle) {
      min-width: 187px;
    }
    .help-bnt {
      position: absolute;
      right: 0;
      /* top: 0; */
    }
  }
`;
